import { Color, Radius, Spacing } from 'zens-storybook'
import React, { Suspense } from 'react'
import { StyleSheet, View } from 'react-native'
import { useNumberParams, useRouter } from 'zens-router'
import { ProductHeader, LayoutHeader, ProductTransfer } from '@dms/component'
import { useTranslation } from 'react-i18next'
import { Draft, ProductTransferData, useProductTransferMutation, useStore } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const ProductTransferScreen = () => {
  const [{ companyId, productId }] = useNumberParams()
  const { t } = useTranslation()
  const { message } = useStore()
  const mutation = useProductTransferMutation({ companyId })
  const router = useRouter()

  async function transfer(draft: Draft<ProductTransferData>) {
    try {
      await mutation.transfer(draft)
      message.add({
        message: t('Device was transfered successfully'),
        status: 'success',
      })
    } catch (error) {
      const { message: errorMessage } = error as Error
      console.debug(`PRODUCT: Product transfer failed: ${errorMessage}`)
      message.add({
        message: `${t('Device could not be transfered')}. ${errorMessage}`,
        status: 'error',
      })
      return
    }
    router.push(`/companies/${companyId}/products`)
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <ProductHeader companyId={companyId} productId={productId} breadcrumbItems={[{ title: t('Transfer') }]} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<ProductTransfer.Skeleton />}>
          <ProductTransfer companyId={companyId} productId={productId} onTransfer={transfer} />
        </Suspense>
      </View>
    </View>
  )
}

export default ProductTransferScreen
